module.exports = {
  fetch: {
    status: {
      pending: '数据加载中...',
      failure: '数据加载失败.',
      success: '',
      error: '服务器请求错误'
    },
    noData: '暂无数据'
  }
}



// WEBPACK FOOTER //
// ./~/rctui/lang/zh-cn/fetch.js